import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatBRL, formatApiErrorDetail } from "@/lib/api";
import AdminLayout from "./AdminLayout";

const STATUSES = ["pending", "paid", "shipped", "delivered", "cancelled"];
const LABEL = { pending: "Pendente", paid: "Pago", shipped: "Enviado", delivered: "Entregue", cancelled: "Cancelado" };

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [expanded, setExpanded] = useState(null);

  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const changeStatus = async (id, status) => {
    try {
      await api.put(`/admin/orders/${id}/status`, { status });
      toast.success("Status atualizado");
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <AdminLayout title="Pedidos">
      <div className="bg-[#0f0f0f] border border-white/5 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-white/40 overline border-b border-white/5">
              <th className="px-5 py-4">Pedido</th>
              <th className="px-5 py-4">Cliente</th>
              <th className="px-5 py-4">Data</th>
              <th className="px-5 py-4">Total</th>
              <th className="px-5 py-4">Pagamento</th>
              <th className="px-5 py-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 && (
              <tr><td colSpan={6} className="px-5 py-8 text-white/40">Nenhum pedido ainda.</td></tr>
            )}
            {orders.map((o) => (
              <>
                <tr key={o.id} data-testid={`admin-order-${o.id}`} className="border-b border-white/5 cursor-pointer hover:bg-white/[0.02]" onClick={() => setExpanded(expanded === o.id ? null : o.id)}>
                  <td className="px-5 py-3">#{o.id.slice(0, 8).toUpperCase()}</td>
                  <td className="px-5 py-3 text-white/60">{o.user_email || o.shipping_name || "Convidado"}</td>
                  <td className="px-5 py-3 text-white/60">{new Date(o.created_at).toLocaleDateString("pt-BR")}</td>
                  <td className="px-5 py-3">{formatBRL(o.total)}</td>
                  <td className="px-5 py-3">
                    <span className={o.payment_status === "paid" ? "text-emerald-400" : "text-white/50"}>{o.payment_status === "paid" ? "Pago" : "Pendente"}</span>
                  </td>
                  <td className="px-5 py-3" onClick={(e) => e.stopPropagation()}>
                    <select data-testid={`order-status-${o.id}`} value={o.status} onChange={(e) => changeStatus(o.id, e.target.value)}
                      className="bg-[#151515] border border-white/10 px-2 py-1 text-xs outline-none focus:border-[#B89C65]">
                      {STATUSES.map((s) => <option key={s} value={s}>{LABEL[s]}</option>)}
                    </select>
                  </td>
                </tr>
                {expanded === o.id && (
                  <tr className="bg-[#151515]">
                    <td colSpan={6} className="px-5 py-4">
                      <p className="overline text-white/40 mb-2">Itens</p>
                      <div className="space-y-2">
                        {o.items.map((it, i) => (
                          <div key={i} className="flex justify-between text-white/70">
                            <span>{it.name} {[it.color, it.size].filter(Boolean).join("/")} × {it.quantity}</span>
                            <span>{formatBRL(it.price * it.quantity)}</span>
                          </div>
                        ))}
                      </div>
                      {o.shipping_address && <p className="text-white/50 text-xs mt-3">Entrega: {o.shipping_name} — {o.shipping_address}</p>}
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
